import script from "./notificationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./notificationPage.vue?vue&type=script&setup=true&lang=js"

import "./notificationPage.vue?vue&type=style&index=0&id=766fba53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-766fba53"]])

export default __exports__